<app-navigation *ngIf="authInfo" [authInfo]="authInfo"></app-navigation>
<ui-view class="container"></ui-view>
